import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { IconEdit, IconSuccess, PrimaryButton, InlineTextButton } from '../../components';
import { TRUST_INDIVIDUAL_LINE } from '../../util/trustCopy';
import css from './StripeConnectAccountStatusBox.module.css';

const STATUS_VERIFICATION_NEEDED = 'verificationNeeded';
const STATUS_VERIFICATION_SUCCESS = 'verificationSuccess';
const STATUS_VERIFICATION_ERROR = 'verificationError';

const GetVerifiedControl = ({ connectHref, disabled, buttonTitle, inProgress, onClick }) => {
  const label = <FormattedMessage id="StripeConnectAccountStatusBox.getVerifiedButton" />;
  if (disabled) {
    return (
      <span className={classNames(css.getVerifiedButton, css.getVerifiedLinkDisabled)} title={buttonTitle}>
        {label}
      </span>
    );
  }
  if (connectHref) {
    return (
      <a
        className={classNames(css.getVerifiedButton, css.getVerifiedLink)}
        href={connectHref}
        target="_top"
        rel="noreferrer"
        title={buttonTitle}
      >
        {label}
      </a>
    );
  }
  return (
    <PrimaryButton
      className={css.getVerifiedButton}
      spinnerClassName={css.spinner}
      type="button"
      inProgress={inProgress}
      onClick={onClick}
      title={buttonTitle}
    >
      {label}
    </PrimaryButton>
  );
};

const StripeConnectAccountStatusBox = props => {
  const {
    type,
    onGetStripeConnectAccountLink,
    connectHref,
    inProgress,
    disabled,
    buttonTitle,
  } = props;

  if (type === STATUS_VERIFICATION_NEEDED) {
    return (
      <div className={classNames(css.verificiationBox, css.verficiationNeededBox)}>
        <div className={css.verificiationBoxTextWrapper}>
          <div className={css.verificationBoxTitle}>
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationNeededTitle" />
          </div>
          <div className={css.verificationBoxText}>
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationNeededText" />
          </div>
          <div className={css.verificationBoxText} data-trust="individual">
            {TRUST_INDIVIDUAL_LINE}
          </div>
        </div>

        <GetVerifiedControl
          connectHref={connectHref}
          disabled={disabled}
          buttonTitle={buttonTitle}
          inProgress={inProgress}
          onClick={onGetStripeConnectAccountLink}
        />
      </div>
    );
  } else if (type === STATUS_VERIFICATION_SUCCESS) {
    return (
      <div className={classNames(css.verificiationBox, css.verficiationSuccessBox)}>
        <div
          className={classNames(
            css.verificiationBoxTextWrapper,
            css.verificationBoxSuccessTextWrapper
          )}
        >
          <div className={css.verificationBoxTitle}>
            <IconSuccess className={css.icon} />
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationSuccessTitle" />
          </div>
        </div>

        {connectHref && !disabled ? (
          <a
            className={css.editVerificationButton}
            href={connectHref}
            target="_top"
            rel="noreferrer"
            title={buttonTitle}
          >
            <IconEdit className={css.icon} pencilClassName={css.iconEditPencil} />
            <FormattedMessage id="StripeConnectAccountStatusBox.editAccountButton" />
          </a>
        ) : (
        <InlineTextButton
          className={css.editVerificationButton}
          spinnerClassName={css.spinner}
          type="button"
          inProgress={inProgress}
          disabled={disabled}
          onClick={onGetStripeConnectAccountLink}
          title={buttonTitle}
        >
          <IconEdit className={css.icon} pencilClassName={css.iconEditPencil} />
          <FormattedMessage id="StripeConnectAccountStatusBox.editAccountButton" />
        </InlineTextButton>
        )}
      </div>
    );
  } else if (type === STATUS_VERIFICATION_ERROR) {
    return (
      <div className={classNames(css.verificiationBox, css.verficiationErrorBox)}>
        <div className={css.verificiationBoxTextWrapper}>
          <div className={css.verificationBoxTitle}>
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationFailedTitle" />
          </div>
          <div className={css.verificationBoxText}>
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationFailedText" />
          </div>
        </div>

        <GetVerifiedControl
          connectHref={connectHref}
          disabled={disabled}
          buttonTitle={buttonTitle}
          inProgress={inProgress}
          onClick={onGetStripeConnectAccountLink}
        />
      </div>
    );
  } else {
    throw new Error(`Unknown type ${type} for StripeConnectAccountStatusBox`);
  }
};

export default StripeConnectAccountStatusBox;
